import axios from 'axios';
import i18n from '../translation/i18n';
import store from '../store';
import { setTokenExpiresAt } from '../component/profile/redux/actions';

const subDomain = window.location.host.split('.')[0];
const domain = window.location.host.split('.')[1];

// ─── Intercepteur requête ─────────────────────────────────────────────────────
axios.interceptors.request.use(
    (config) => {
        const requestUrl = config.url ?? '';
        const isApiRequest = requestUrl.includes(API_HREF) || requestUrl.includes(API_HREF_V2) || requestUrl.includes('/api/schema/json/');

        if (!isApiRequest) {
            return config;
        }

        if (!config.headers['Accept']) {
            config.headers['Accept'] = 'application/json';
        }

        if (!config.headers['Content-Type']) {
            config.headers['Content-Type'] = 'application/json';
        }

        if(subDomain !== 'vat-dev' && subDomain !== 'vat') {
            config.headers['X-ENVIRONMENT'] = 'BO';
        }
        config.headers['Accept-Language'] = i18n.language;

        if (config.headers['X-Public-Request']) {
            delete config.headers['X-Public-Request'];
            return config;
        }

        const token = localStorage.getItem('token');
        if (token) {
            config.headers['Authorization'] = `Token ${token}`;
        }

        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// ─── Intercepteur réponse ────────────────────────────────────────────────────
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            localStorage.removeItem('token');
            store.dispatch(setTokenExpiresAt(null));
            window.location.href = `${WP_BASE_HREF}/login`;
        }
        return Promise.reject(error);
    }
);

export default axios;
